export default {
  title: {
    id: 'buyback_refurbisher_order_customer_info_title',
    defaultMessage: 'Customer Information',
  },
  addressLabel: {
    id: 'buyback_refurbisher_order_address_label',
    defaultMessage: 'Address',
  },
  trackingNumber: {
    id: 'buyback_refurbisher_order_parcel_number_label',
    defaultMessage: 'Parcel Number',
  },
  identityLabel: {
    id: 'buyback_refurbisher_order_identity_label',
    defaultMessage: 'Identity',
  },
  saleVoucherLabel: {
    id: 'buyback_refurbisher_order_sale_voucher_label',
    defaultMessage: 'Sale Voucher',
  },
  download: {
    id: 'buyback_refurbisher_order_download_label',
    defaultMessage: 'Download',
  },
  phoneNumber: {
    id: 'buyback_refurbisher_order_phone_number',
    defaultMessage: 'Phone',
  },
  contactCustomer: {
    id: 'buyback_refurbisher_order_contact_customer',
    defaultMessage: 'Contact customer',
  },
}
